/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useField } from '@unform/core';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { IconBaseProps } from 'react-icons';
import * as Yup from 'yup';

import { Container, Label, Error } from './styles';

interface InputProps extends NumberFormatProps {
  label?: string;
  name: string;
  value?: string;
  icon?: React.ComponentType<IconBaseProps> | any;
  schema?: Yup.ObjectSchema;
}

const InputCurrency: React.FC<InputProps> = ({
  name,
  label,
  value = '',
  icon: Icon,
  schema,
  ...rest
}) => {
  const inputRef = useRef<any>(null);
  const NumberFormatRef = useRef<any>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [data, setData] = useState('');
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  const handleChange = useCallback(async () => {
    try {
      if (schema) {
        const isValid = await Yup.reach(schema, fieldName).validate(
          inputRef.current?.value,
          { abortEarly: true },
        );
        setIsCorrect(!!isValid);
      }
    } catch (err) {
      setIsCorrect(false);
    }
  }, [schema, fieldName]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: NumberFormatRef.current,
      getValue: ref => {
        if (ref.state.numAsString) {
          return Number(ref.state.numAsString);
        }
        return '';
      },
    });
  }, [fieldName, inputRef, registerField]);

  useEffect(() => {
    console.log(value);
    setData(value);
  }, [value]);

  return (
    <>
      <Label htmlFor={name}>{label}</Label>
      <Container
        isErrored={!!error}
        isFilled={isFilled}
        isFocused={isFocused}
        isCorrect={isCorrect}
      >
        <NumberFormat
          getInputRef={inputRef}
          ref={NumberFormatRef}
          prefix="R$ "
          thousandSeparator="."
          decimalSeparator=","
          fixedDecimalScale
          decimalScale={2}
          defaultValue={defaultValue}
          allowNegative={false}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onValueChange={handleChange}
          value={data}
          onChange={(e: any) => setData(e.target.value)}
          {...rest}
        />
        {Icon && <Icon size={20} />}
      </Container>
      {!isCorrect && <Error>{error}</Error>}
    </>
  );
};

export default InputCurrency;
